import { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Typography, Box } from '@mui/material';

import { AdminRoles, DoctorRoles, Role } from '../../config/DiactiveTypes';
import { calculateWorkoutsPerWeek, formatDateTime } from '../../utils/DiactiveUtils';
import { getArrowString } from '../../utils/TrendArrowUtils';
import SendEmailButton from '../common/SendEmailButton';

const WorkoutHistoryTable = ({ authUserRole, patientRole, workouts, canTrain, hasFilledQsPre, glucoseFileCount, onSendReminderClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const isAdminRole = AdminRoles.includes(authUserRole);
  const isDoctorRole = DoctorRoles.includes(authUserRole);
  const isIntrPatient = patientRole === Role.Intr25;

  const workoutsPerWeek = calculateWorkoutsPerWeek(workouts);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const labelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`;
  };

  const showStartTrainingButton = isAdminRole && isIntrPatient && !canTrain;
  const showRemindTrainingButton = (isAdminRole || isDoctorRole) && isIntrPatient && canTrain;

  return (
    <Box>
      {showStartTrainingButton &&
        <SendEmailButton
          text="Comenzar Entrenamiento"
          disabled={glucoseFileCount.pre === 0 || !hasFilledQsPre}
          onClick={onSendReminderClick}
        />
      }
      {showRemindTrainingButton &&
        <SendEmailButton
          text="Recordar Entrenamiento"
          onClick={onSendReminderClick}
        />
      }

      {workouts.length > 0 && (
        <Typography variant="body2" sx={{ fontWeight: 'bold', mt: 4, mb: -3, textAlign: 'center' }}>
          Promedio de sesiones por semana: {workoutsPerWeek.toString().replace('.', ',')}
        </Typography>
      )}

      <TableContainer sx={{mt: 4}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fecha</TableCell>
              <TableCell>Número de ejercicios</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Nivel de satisfacción</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Frecuencia cardíaca media</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Glucemia pre</TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Glucemia post</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {workouts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((workout) => (
              <TableRow key={workout.id}>
                <TableCell>
                  {formatDateTime(workout.createdAt)}
                </TableCell>
                <TableCell>{workout.exercises.length}</TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {workout.rating}
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {workout.heartRateAvg === -1 ? "-" : workout.heartRateAvg}
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {`${workout.glycemiaPre} ${getArrowString(workout.trendArrowType, workout.trendArrowPre)}`}
                </TableCell>
                <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                  {`${workout.glycemiaPost} ${getArrowString(workout.trendArrowType, workout.trendArrowPost)}`}
                </TableCell>
              </TableRow>
            ))}
            {workouts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6}>
                  <Typography variant="body2" color="text.secondary" align="center">
                    No hay sesiones de entrenamiento
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={workouts.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Filas por página"
          labelDisplayedRows={labelDisplayedRows}
        />
      </TableContainer>
    </Box>
  );
};

export default WorkoutHistoryTable;